/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainParentVolunteerStatus = 'Requested' | 'Approved' | 'Rejected' | 'Revoked' | 'Removed';

export const DomainParentVolunteerStatus = {
    Requested: 'Requested' as DomainParentVolunteerStatus,
    Approved: 'Approved' as DomainParentVolunteerStatus,
    Rejected: 'Rejected' as DomainParentVolunteerStatus,
    Revoked: 'Revoked' as DomainParentVolunteerStatus,
    Removed: 'Removed' as DomainParentVolunteerStatus
};